import { render } from "./DashboardYield.vue?vue&type=template&id=3c3d19be&scoped=true"
import script from "./DashboardYield.vue?vue&type=script&lang=js"
export * from "./DashboardYield.vue?vue&type=script&lang=js"

import "./DashboardYield.vue?vue&type=style&index=0&id=3c3d19be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3d19be"]])

export default __exports__